export default function themeToggle() {
    return {
        dark: false,

        get isLight() {
            return !this.dark;
        },

        get ariaLabel() {
            return this.dark ? 'Switch to light mode' : 'Switch to dark mode';
        },

        toggle() {
            this.dark = !this.dark;
            document.documentElement.classList.toggle('dark');
            localStorage.setItem('theme', this.dark ? 'dark' : 'light');
        },

        init() {
            this.dark = document.documentElement.classList.contains('dark');
        },

        destroy() {},
    };
}
